import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { initialMesaiNoktasiListIstegi, MesaiNoktasiItem, MesaiNoktasiListIstegi, MesaiNoktasiListSonucu, MesaiNoktasiService, NOKTA_TURLERI } from '../../../services/MesaiNoktasiService';
import { qrYazdir } from '../../../components/QrEtiket/qrYazdir';
import { etiketleriDiz, noktaEtiketleri, QR_RENKLERI } from '../../../components/QrEtiket/noktaEtiketleri';
import { QRCodeSVG } from 'qrcode.react';

/** Listede küçük QR önizlemesi: çerçeve rengi iş tipini gösterir (Lojistik mavi, Ambalaj turuncu, ofis mor). */
const KucukQr = ({ metin, renk, etiket }: { metin: string, renk: string, etiket: string }) => (
    <span className='d-inline-flex flex-column align-items-center me-2' title={etiket}>
        <span className='d-inline-block bg-white rounded p-1' style={{ border: '2px solid ' + renk, lineHeight: 0 }}>
            <QRCodeSVG value={metin} size={34} level='L' includeMargin={false} />
        </span>
        <span className='fs-9 fw-bolder' style={{ color: renk }}>{etiket}</span>
    </span>
);
import MesaiNoktasiListFilters from './Components/MesaiNoktasiListFilters';

/**
 * QR Noktaları listesi (standart liste ekranı, 11.10.2026; Sabit Gelir Dağıtımı listesiyle aynı kalıp).
 * Depoya asılan QR; personel mesai başı / sonu için okutur.
 */
const MesaiNoktasiList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pageName = "İnsan Kaynakları > Tanımlamalar > QR Noktaları"
    // Sürüm 2 (Faz 1b): Fatura Ataması / Atama / Dağıtım Özeti kolonları kaldırıldı; kayıtlı eski kolon düzeni kullanılmaz.
    const pageVersion = "2";
    const [data, setData] = useState<MesaiNoktasiListSonucu>({ list: [], totalRecordCount: 0 });
    const [filter, setFilter] = useState<MesaiNoktasiListIstegi>(initialMesaiNoktasiListIstegi)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'QR', name: 'qr', order: 0, isVisible: true },
            { title: 'Ad', name: 'ad', order: 0, isVisible: true },
            { title: 'Tür', name: 'turAdi', order: 0, isVisible: true },
            { title: 'Konum', name: 'konum', order: 0, isVisible: true },
            { title: 'Yarıçap (m)', name: 'yaricap', order: 0, isVisible: true },
            { title: 'QR Kodu (Lojistik / Ofis)', name: 'qrKodu', order: 0, isVisible: true },
            { title: 'Ambalaj QR Kodu', name: 'qrKoduAmbalaj', order: 0, isVisible: true },
            { title: 'Yetkili Personeller', name: 'yetkiliOzeti', order: 0, isVisible: true },
            { title: 'Müşteri / Bölüm', name: 'musteriOzeti', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteMesaiNoktasi = async () => {
        try {
            var selectedIds = data.list.filter(x => x.isSelected).map(x => x.mesaiNoktasiId);

            dispatch(storeActivityIndicator(true))

            var response = await MesaiNoktasiService.sil(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success('Seçilen QR noktaları silindi.')

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateMesaiNoktasi = async (_id: string | undefined = undefined) => {
        navigate('/mesainoktasi/listadd?id=' + (_id ? _id : data.list.filter(x => x.isSelected)[0].mesaiNoktasiId));
    }

    const qrYazdirSecilenler = () => {
        var secilenler = data.list.filter(x => x.isSelected && x.qrMetni);

        if (secilenler.length == 0) {
            toast.error('Yazdırılacak satırları seçin');
            return;
        }

        // Depo'nun Lojistik + Ambalaj etiketleri birlikte (aynı satırda) basılır; ofis tek etiket.
        qrYazdir(etiketleriDiz(secilenler.map(x => noktaEtiketleri(x))));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: MesaiNoktasiListIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response = await MesaiNoktasiService.getListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            list: data.list.map(function (x) {
                if (x.mesaiNoktasiId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.list.length == data.list.filter(x => x.isSelected).length;

        setData({
            ...data,
            list: data.list.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await MesaiNoktasiService.exportList(buildExcelRequest(filter, mode, data.list.filter(x => x.isSelected).map(x => x.mesaiNoktasiId), columns));

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Konum hesaplanan kolon olduğu için yok.
    const sortableColumns = [
        'ad', 'turAdi', 'yaricap', 'qrKodu', 'qrKoduAmbalaj', 'isCustomActive'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        ad: { type: 'text' },
        // Tür seçimle süzülür (değer: 1 Depo, 2 Ofis).
        turAdi: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(NOKTA_TURLERI.map(x => ({ value: String(x.value), label: x.label }))) },
        yaricap: { type: 'number' },
        qrKodu: { type: 'text' },
        qrKoduAmbalaj: { type: 'text' },
        isCustomActive: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: MesaiNoktasiItem, column: string, index: number, className: string | undefined) => {
        if (column == "isCustomActive") {
            return (
                <td className={className} onClick={() => setItemSelected(item.mesaiNoktasiId)} onDoubleClick={() => updateMesaiNoktasi(item.mesaiNoktasiId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.mesaiNoktasiId)} onDoubleClick={() => updateMesaiNoktasi(item.mesaiNoktasiId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.mesaiNoktasiId)} onDoubleClick={() => updateMesaiNoktasi(item.mesaiNoktasiId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (column == "qr") {
            return (
                <td className={className} onClick={() => setItemSelected(item.mesaiNoktasiId)} onDoubleClick={() => updateMesaiNoktasi(item.mesaiNoktasiId)}>
                    <div className='d-flex'>
                        {item.qrMetni && <KucukQr metin={item.qrMetni} renk={item.tur == 2 ? QR_RENKLERI.ofis : QR_RENKLERI.lojistik} etiket={item.tur == 2 ? 'OFİS' : 'LOJİSTİK'} />}
                        {item.tur != 2 && item.qrMetniAmbalaj && <KucukQr metin={item.qrMetniAmbalaj} renk={QR_RENKLERI.ambalaj} etiket='AMBALAJ' />}
                    </div>
                </td>
            )
        }
        else if (column == "turAdi") {
            return (
                <td className={className} onClick={() => setItemSelected(item.mesaiNoktasiId)} onDoubleClick={() => updateMesaiNoktasi(item.mesaiNoktasiId)}>
                    <span className={'badge ebbe-status-badge ' + (item.tur == 2 ? 'badge-light-info' : 'badge-light-primary')}>{item.turAdi || (item.tur == 2 ? 'Ofis' : 'Depo')}</span>
                </td>
            )
        }
        else if (column == "konum") {
            return (
                <td className={className} onClick={() => setItemSelected(item.mesaiNoktasiId)} onDoubleClick={() => updateMesaiNoktasi(item.mesaiNoktasiId)}>{item.lat != null && item.lon != null ? `${item.lat}, ${item.lon}` : ''}</td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.mesaiNoktasiId)} onDoubleClick={() => updateMesaiNoktasi(item.mesaiNoktasiId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <MesaiNoktasiListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.list.filter(x => x.isSelected).length}
                    deleteFunction={deleteMesaiNoktasi}
                    updateFunction={updateMesaiNoktasi}
                    onSearchSubmit={onSearchSubmit}
                    qrYazdirFunction={qrYazdirSecilenler}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.list.filter(x => x.isSelected).length > 0 && data.list.filter(x => x.isSelected).length == data.list.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.mesaiNoktasiId)} className='form-check-input' type='checkbox' checked={item.isSelected ?? false} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.list.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default MesaiNoktasiList;
